// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_yard_management_ui_styles" + "." + "4e03f090" + ".chunk.css";
};